const formatPrice = (price) => {
    let decimalDigits = 2;
    let currency = '';
    if (typeof window.__STATE__ !== 'undefined') {
        decimalDigits = window.__STATE__.localization.decimal_digits;
        currency = window.__STATE__.localization.currency;
    }
    return `${price.toFixed(decimalDigits)}${currency}`;
};
export { formatPrice };
